import { useRef, useState } from 'react';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { ReactComponent as UploadIcon } from '../../../icons/upload.svg';

export interface IAudioFileUploadProps {
    onFilesSelected: (files: File[]) => void;
}

const isMp3 = (file: File) => file.type === 'audio/mpeg' || file.name.toLowerCase().endsWith('.mp3');

function AudioFileUpload({ onFilesSelected }: IAudioFileUploadProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [dragging, setDragging] = useState(false);

    const handleFiles = (list: FileList | null) => {
        const files = Array.from(list ?? []);
        const valid = files.filter(isMp3);
        if (valid.length !== files.length)
            toast.error('Only MP3 files are supported.');
        if (valid.length > 0)
            onFilesSelected(valid);
    };

    return (
        <Box
            onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={(e) => { e.preventDefault(); setDragging(false); handleFiles(e.dataTransfer.files); }}
            sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2,
                p: 3, minHeight: 220, textAlign: 'center',
                border: '2px dashed', borderColor: dragging ? 'primary.main' : 'divider', borderRadius: 2,
                backgroundColor: dragging ? 'action.hover' : 'transparent',
            }}
        >
            <SvgIcon component={UploadIcon} inheritViewBox color='primary' sx={{ fontSize: 56 }} />
            <Typography color='primary'>Drop MP3 files here or click 'Upload'</Typography>
            <Button variant='contained' onClick={() => inputRef.current?.click()}>Upload</Button>
            <input
                ref={inputRef}
                type='file'
                accept='.mp3,audio/mpeg'
                multiple
                hidden
                onChange={(e) => { handleFiles(e.target.files); e.target.value = ''; }}
            />
        </Box>
    );
}

export default AudioFileUpload;
